var React = require( 'react' );
var createReactClass = require('create-react-class');
var DropDownList = require('./dropDownList.jsx');

var NumericPicker = createReactClass({

  loadDigits: function() {
    var digits = [];

    for(var i=this.props.start; i <= this.props.end; i++) {
      var digit = {"id": i, "value": i, "title": i}
      digits.push(digit);
    };

    return digits;
  },

  render: function(){
    var digitList = this.loadDigits();
    return (
        <DropDownList list={digitList} value={this.props.value} onChange={this.props.onChange} />
    );
  }
});

module.exports = NumericPicker;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/pickers/numericPicker.jsx